import type { PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'

import { useSession } from '@/core/auth/hooks/useSession'
import { sessionService } from '@/core/auth/session/session.service'
import { getStoredToken } from '@/core/auth/session/session.storage'

type AuthGuardProps = PropsWithChildren

export function AuthGuard({ children }: AuthGuardProps) {
  const { status, isAuthenticated, expiresAtUtc } = useSession()

  if (status === 'loading') return null

  const tokenExpired = expiresAtUtc != null && new Date(expiresAtUtc) <= new Date()
  const hasAccessToken = Boolean(getStoredToken())

  if (!isAuthenticated || !hasAccessToken || tokenExpired) {
    if (tokenExpired) sessionService.clearSession()
    return <Navigate replace to="/login" />
  }

  return <>{children}</>
}
